import Messages from './Messages';

export default Messages;
